// import axios from "axios";
// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import ApiUrl from "./../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function EditStock() {
//   const navigate = useNavigate();
//   const toast = useToast();
//   const { stock_ids } = useParams(); // Extract stock_ids from URL (e.g., "65")

//   const [items, setItems] = useState([]);
//   const [typeGetting, setTypeGetting] = useState([]);
//   const [editingIndex, setEditingIndex] = useState(null);

//   const [addData, setAddData] = useState({
//     item: "",
//     quantity: "",
//     category: "",
//     weight: "",
//     date: new Date().toISOString().split("T")[0],
//     updated_by: "admin", // Replace with actual user data
//     status: "In Stock",
//     overall_stock_id: stock_ids || "",
//     type_id: "",
//   });

//   useEffect(() => {
//     fetchProductType();
//     if (stock_ids) {
//       fetchStockDetails(stock_ids);
//     } else {
//       toast.error("No stock IDs provided in URL", 3000, "topRight");
//     }
//   }, [stock_ids]);

//   const fetchProductType = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setTypeGetting(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching product types:", error.message);
//       setTypeGetting([]);
//       toast.error("Error fetching product types", 3000, "topRight");
//     }
//   };

//   const fetchStockDetails = async (stockIds) => {
//     if (!stockIds) {
//       toast.error("No stock IDs provided", 3000, "topRight");
//       return;
//     }
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/stock.php?stock_ids=${stockIds}`);
//       const stockData = response.data?.data || [];
//       const formattedItems = stockData.reduce((acc, stock) => {
//         if (stock.stock_list) {
//           const stockItems = stock.stock_list.map((item) => {
//             if (item.id && !isNaN(item.id)) {
//               return {
//                 id: item.id,
//                 date: item.date || new Date().toISOString().split("T")[0],
//                 status: item.status || "In Stock",
//                 item: item.item,
//                 type_id: item.type_id || item.item,
//                 quantity: parseInt(item.quantity) || 0,
//                 category: item.category || "",
//                 weight: parseFloat(item.weight?.replace("g", "") || 0).toFixed(2),
//                 created_by: item.created_by || "admin",
//                 created_date: item.created_date || new Date().toISOString(),
//                 updated_by: item.updated_by || "admin",
//                 updated_date: item.updated_date || new Date().toISOString(),
//                 overall_stock_id: item.overall_stock_id || stockIds.split(",")[0],
//               };
//             }
//             return null;
//           }).filter(item => item !== null);
//           return [...acc, ...stockItems];
//         }
//         return acc;
//       }, []);
//       setItems(formattedItems);
//     } catch (error) {
//       console.error("Error fetching stock details:", error.message);
//       toast.error("Error fetching stock details", 3000, "topRight");
//     }
//   };

//   const updateStockListItem = async (item) => {
//     try {
//       const payload = {
//         date: item.date,
//         overall_stock_id: item.overall_stock_id || stock_ids,
//         status: item.status,
//         item: item.item,
//         type_id: item.type_id || item.item,
//         quantity: item.quantity.toString(),
//         category: item.category,
//         weight: `${item.weight}g`,
//         updated_by: addData.updated_by,
//         updated_date: new Date().toISOString(),
//       };

//       const response = await axios.put(`${ApiUrl}/Api/stock_list.php/${item.id}`, payload);

//       toast.success("Stock list item updated successfully!", 3000, "topRight");
//       return response.data;
//     } catch (error) {
//       console.error("Error updating stock list item:", error.message);
//       toast.error(
//         "Error updating stock list item: " + (error.response?.data?.message || error.message),
//         3000,
//         "topRight"
//       );
//       throw error;
//     }
//   };

//   const handleAddItem = async () => {
//     if (
//       !addData.category ||
//       !addData.item ||
//       !addData.quantity ||
//       !addData.weight ||
//       !addData.date ||
//       !addData.status ||
//       !addData.overall_stock_id
//     ) {
//       toast.error("Please fill all required fields", 3000, "topRight");
//       return;
//     }

//     if (!/^\d+$/.test(addData.quantity)) {
//       toast.error("Quantity must be a positive integer", 3000, "topRight");
//       return;
//     }

//     if (!/^\d*\.?\d{0,2}$/.test(addData.weight)) {
//       toast.error("Weight must be a valid number with up to 2 decimal places", 3000, "topRight");
//       return;
//     }

//     const selectedType = typeGetting.find((type) => type._id === addData.item);
//     const typeName = selectedType ? selectedType.type : addData.item;

//     const newItem = {
//       id: editingIndex !== null ? items[editingIndex].id : null,
//       date: addData.date,
//       status: addData.status,
//       item: typeName,
//       type_id: addData.item,
//       quantity: parseInt(addData.quantity),
//       category: addData.category,
//       weight: parseFloat(addData.weight).toFixed(2),
//       created_by: editingIndex !== null ? items[editingIndex].created_by : addData.updated_by,
//       created_date: editingIndex !== null ? items[editingIndex].created_date : new Date().toISOString(),
//       updated_by: addData.updated_by,
//       updated_date: new Date().toISOString(),
//       overall_stock_id: addData.overall_stock_id,
//     };

//     if (editingIndex !== null && newItem.id) {
//       // Update existing item
//       await updateStockListItem(newItem);
//       const updatedItems = [...items];
//       updatedItems[editingIndex] = newItem;
//       setItems(updatedItems);
//       setEditingIndex(null);
//     } else {
//       // Add new item
//       setItems([...items, newItem]);
//     }

//     setAddData({
//       item: "",
//       quantity: "",
//       weight: "",
//       category: "",
//       date: new Date().toISOString().split("T")[0],
//       updated_by: "admin",
//       status: "In Stock",
//       overall_stock_id: stock_ids || "",
//       type_id: "",
//     });
//   };

//   const handleEditItem = (index) => {
//     const itemToEdit = items[index];
//     setAddData({
//       item: itemToEdit.type_id || itemToEdit.item,
//       quantity: itemToEdit.quantity.toString(),
//       category: itemToEdit.category,
//       weight: itemToEdit.weight,
//       date: itemToEdit.date,
//       updated_by: addData.updated_by,
//       status: itemToEdit.status,
//       overall_stock_id: itemToEdit.overall_stock_id,
//       type_id: itemToEdit.type_id,
//     });
//     setEditingIndex(index);
//   };

//   const handleRemoveItem = (index) => {
//     const updatedItems = items.filter((_, i) => i !== index);
//     setItems(updatedItems);
//     setEditingIndex(null);
//   };

//   const calculateTotals = () => {
//     const totalQuantity = items.reduce(
//       (sum, item) => sum + parseInt(item.quantity || 0),
//       0
//     );
//     const totalWeight = items.reduce(
//       (sum, item) => sum + parseFloat(item.weight || 0),
//       0
//     );

//     return {
//       total_quantity: totalQuantity,
//       total_weight: totalWeight.toFixed(2),
//       avaliable_quantity: totalQuantity,
//       sold_quantity: 0,
//     };
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return;
//     }

//     if (!stock_ids) {
//       toast.error("No stock IDs provided for update", 3000, "topRight");
//       return;
//     }

//     try {
//       const totals = calculateTotals();
//       const mainCategory = items[0]?.category || "";
//       const mainItemName =
//         items.length === 1 ? items[0].item : `${mainCategory} Items`;

//       const payload = {
//         item: mainItemName,
//         quantity: totals.total_quantity.toString(),
//         amount: "0.00",
//         category: mainCategory,
//         weight: `${totals.total_weight}g`,
//         avaliable_quantity: totals.avaliable_quantity.toString(),
//         total_quantity: totals.total_quantity.toString(),
//         sold_quantity: totals.sold_quantity.toString(),
//         updated_by: addData.updated_by,
//         updated_date: new Date().toISOString(),
//         stock_list: items.map((item) => ({
//           id: item.id || null,
//           date: item.date,
//           status: item.status,
//           item: item.item,
//           type_id: item.type_id || item.item,
//           quantity: item.quantity.toString(),
//           category: item.category,
//           weight: `${item.weight}g`,
//           created_by: item.created_by || addData.updated_by,
//           created_date: item.created_date || new Date().toISOString(),
//           updated_by: addData.updated_by,
//           updated_date: new Date().toISOString(),
//           overall_stock_id: item.overall_stock_id || stock_ids,
//         })),
//       };

//       const response = await axios.put(`${ApiUrl}/Api/stock.php?stock_ids=${stock_ids}`, payload);

//       toast.success("Stock updated successfully!", 3000, "topRight");
//       setItems([]);
//       navigate("/stocks");
//     } catch (error) {
//       console.error("Error submitting data:", error.message);
//       toast.error(
//         "Error submitting data: " + (error.response?.data?.message || error.message),
//         3000,
//         "topRight"
//       );
//     }
//   };

//   return (
//     <div className="container-fluid">
//       <div className="card card-body">
//         <h6 className="mb-3">{stock_ids ? "Edit Stock Items" : "Add Stock Items"}</h6>
//         <div className="row">
//           <div className="col-md-2">
//             <label className="form-label">Date</label>
//             <input
//               type="date"
//               className="form-control"
//               value={addData.date}
//               onChange={(e) =>
//                 setAddData({ ...addData, date: e.target.value })
//               }
//               required
//             />
//           </div>

//           <div className="col-md-2">
//             <label className="form-label">Category</label>
//             <select
//               className="form-select"
//               value={addData.category}
//               onChange={(e) =>
//                 setAddData({ ...addData, category: e.target.value })
//               }
//               required
//             >
//               <option value="">Select Category</option>
//               <option value="Gold">Gold</option>
//               <option value="Silver">Silver</option>
//               <option value="Jewelry">Jewelry</option>
//             </select>
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">Type</label>
//             <select
//               className="form-select"
//               value={addData.item}
//               onChange={(e) => {
//                 setAddData({ ...addData, item: e.target.value, type_id: e.target.value });
//               }}
//               required
//             >
//               <option value="">Select Type</option>
//               {typeGetting.map((item) => (
//                 <option key={item._id} value={item._id}>
//                   {item.type}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="col-md-1">
//             <label className="form-label">Quantity</label>
//             <input
//               type="text"
//               inputMode="numeric"
//               className="form-control"
//               placeholder="Quantity"
//               value={addData.quantity}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d{0,5}$/.test(value)) {
//                   setAddData({ ...addData, quantity: value });
//                 }
//               }}
//               required
//             />
//           </div>

//           <div className="col-md-2">
//             <label className="form-label">Weight (g)</label>
//             <input
//               type="text"
//               inputMode="decimal"
//               className="form-control"
//               placeholder="Weight"
//               value={addData.weight}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d*\.?\d{0,2}$/.test(value)) {
//                   setAddData({ ...addData, weight: value });
//                 }
//               }}
//               required
//             />
//           </div>

//           <div className="col-md-2">
//             <label className="form-label">Status</label>
//             <select
//               className="form-select"
//               value={addData.status}
//               onChange={(e) =>
//                 setAddData({ ...addData, status: e.target.value })
//               }
//               required
//             >
//               <option value="In Stock">In Stock</option>
//               <option value="Out of Stock">Out of Stock</option>
//             </select>
//           </div>

//           <div className="col-md-1 d-flex align-items-end">
//             <button
//               className={`btn btn-sm w-100 ${
//                 editingIndex === null ? "btn-success" : "btn-primary"
//               }`}
//               onClick={handleAddItem}
//               type="button"
//             >
//               <i
//                 className={`bi ${
//                   editingIndex === null ? "bi-plus" : "bi-check"
//                 }`}
//               ></i>
//             </button>
//           </div>

//           <div className="col-md-2 col-lg-2 col-sm-3 d-flex align-items-end">
//             <button
//               className="btn btn-primary w-100"
//               onClick={handleSubmit}
//               disabled={items.length === 0}
//             >
//               {stock_ids ? "Update" : "Submit"}
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="container-fluid py-3">
//         <div className="card shadow-sm">
//           <div className="card-body">
//             {items.length > 0 && (
//               <div className="row mb-3">
//                 <div className="col-md-12">
//                   <div className="alert alert-info">
//                     <strong>Summary:</strong>
//                     Total Items: {items.length} | Total Quantity:{" "}
//                     {items.reduce(
//                       (sum, item) => sum + parseInt(item.quantity || 0),
//                       0
//                     )}{" "}
//                     | Total Weight:{" "}
//                     {items.reduce(
//                       (sum, item) => sum + parseFloat(item.weight || 0),
//                       0
//                     ).toFixed(2)}
//                     g
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="card tableCard p-2">
//               <div className="table-responsive">
//                 <table className="table">
//                   <thead className="bg-light">
//                     <tr>
//                       <th>S.No</th>
//                       <th>Date</th>
//                       <th>Category</th>
//                       <th>Item</th>
//                       <th>Quantity</th>
//                       <th>Weight (g)</th>
//                       <th>Status</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {items.length > 0 ? (
//                       items.map((item, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{item.date}</td>
//                           <td>{item.category}</td>
//                           <td>{item.item}</td>
//                           <td>{item.quantity}</td>
//                           <td>{item.weight}g</td>
//                           <td>{item.status}</td>
//                           <td>
//                             <button
//                               className="btn btn-sm btn-light me-1"
//                               onClick={() => handleEditItem(index)}
//                             >
//                               <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                             </button>
//                             <button
//                               className="btn btn-sm btn-light"
//                               onClick={() => handleRemoveItem(index)}
//                             >
//                               <i className="fa-solid fa-trash text-danger fs-6"></i>
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" className="text-center">
//                           No items added yet
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default EditStock;


import axios from "axios";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ApiUrl from "./../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";

function EditStock() {
  const navigate = useNavigate();
  const toast = useToast();
  const { stock_ids } = useParams();

  const [items, setItems] = useState([]);
  const [products, setProducts] = useState([]); // Changed from typeGetting
  const [filteredProducts, setFilteredProducts] = useState([]); // For category filtering
  const [editingIndex, setEditingIndex] = useState(null);

  const [addData, setAddData] = useState({
    item: "",
    quantity: "",
    category: "",
    weight: "",
    date: new Date().toISOString().split("T")[0],
    updated_by: "admin",
    status: "In Stock",
    overall_stock_id: stock_ids || "",
    product_id: "",
  });

  useEffect(() => {
    fetchProducts();
    if (stock_ids) {
      fetchStockDetails(stock_ids);
    } else {
      toast.error("No stock IDs provided in URL", 3000, "topRight");
    }
  }, [stock_ids]);

  // Filter products based on selected category
  useEffect(() => {
    if (addData.category) {
      const filtered = products.filter(product => 
        product.category === addData.category
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [addData.category, products]);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/product.php`);
      setProducts(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching products:", error.message);
      setProducts([]);
      toast.error("Error fetching products", 3000, "topRight");
    }
  };

  const fetchStockDetails = async (stockIds) => {
    if (!stockIds) {
      toast.error("No stock IDs provided", 3000, "topRight");
      return;
    }
    try {
      const response = await axios.get(`${ApiUrl}/Api/stock.php?stock_ids=${stockIds}`);
      console.log("API Response:", response.data);
      const stockData = response.data?.data || [];
      console.log("Stock Data:", stockData);

      const stockIdsArray = stockIds.split(",");

      const formattedItems = stockData.reduce((acc, stock) => {
        if (stock.stock_list && Array.isArray(stock.stock_list)) {
          const matchingItems = stock.stock_list
            .filter(item => item.overall_stock_id && stockIdsArray.includes(String(item.overall_stock_id)))
            .map(item => {
              // Find the product to get its Tamil name
              const product = products.find(p => 
                (p.item_name_english === item.item || p.item_name === item.item)
              );
              return {
                id: item.id,
                date: item.date || new Date().toISOString().split("T")[0],
                status: item.status || "In Stock",
                item: item.item,
                item_tamil: product?.item_name_tamil || "",
                product_id: item.product_id || item.type_id || item.item,
                quantity: parseInt(item.quantity) || 0,
                category: item.category || "",
                weight: parseFloat(item.weight?.replace("g", "") || 0).toFixed(2),
                created_by: item.created_by || "admin",
                created_date: item.created_date || new Date().toISOString(),
                updated_by: item.updated_by || "admin",
                updated_date: item.updated_date || new Date().toISOString(),
                overall_stock_id: item.overall_stock_id,
              };
            });
          return [...acc, ...matchingItems];
        }
        return acc;
      }, []);

      console.log("Formatted Items:", formattedItems);
      setItems(formattedItems);
    } catch (error) {
      console.error("Error fetching stock details:", error.message);
      toast.error("Error fetching stock details", 3000, "topRight");
    }
  };

  const updateStockListItem = async (item) => {
    try {
      const payload = {
        date: item.date,
        overall_stock_id: item.overall_stock_id || stock_ids,
        status: item.status,
        item: item.item,
        product_id: item.product_id,
        quantity: item.quantity.toString(),
        category: item.category,
        weight: `${item.weight}g`,
        updated_by: addData.updated_by,
        updated_date: new Date().toISOString(),
      };

      const response = await axios.put(`${ApiUrl}/Api/Stock_list.php/${item.id}`, payload);

      toast.success("Stock list item updated successfully!", 3000, "topRight");
      return response.data;
    } catch (error) {
      console.error("Error updating stock list item:", error.message);
      toast.error(
        "Error updating stock list item: " + (error.response?.data?.message || error.message),
        3000,
        "topRight"
      );
      throw error;
    }
  };

  const handleAddItem = async () => {
    if (
      !addData.category ||
      !addData.item ||
      !addData.quantity ||
      !addData.weight ||
      !addData.date ||
      !addData.status ||
      !addData.overall_stock_id
    ) {
      toast.error("Please fill all required fields", 3000, "topRight");
      return;
    }

    if (!/^\d+$/.test(addData.quantity)) {
      toast.error("Quantity must be a positive integer", 3000, "topRight");
      return;
    }

    if (!/^\d*\.?\d{0,2}$/.test(addData.weight)) {
      toast.error("Weight must be a valid number with up to 2 decimal places", 3000, "topRight");
      return;
    }

    // Get selected product details
    const selectedProduct = products.find((product) => String(product.id) === String(addData.item));
    const productName = selectedProduct
      ? (selectedProduct.item_name_english || selectedProduct.item_name)
      : addData.item;
    const productTamil = selectedProduct?.item_name_tamil || "";

    const newItem = {
      id: editingIndex !== null ? items[editingIndex].id : null,
      date: addData.date,
      status: addData.status,
      item: productName,
      item_tamil: productTamil,
      product_id: addData.item,
      quantity: parseInt(addData.quantity),
      category: addData.category,
      weight: parseFloat(addData.weight).toFixed(2),
      created_by: editingIndex !== null ? items[editingIndex].created_by : addData.updated_by,
      created_date: editingIndex !== null ? items[editingIndex].created_date : new Date().toISOString(),
      updated_by: addData.updated_by,
      updated_date: new Date().toISOString(),
      overall_stock_id: addData.overall_stock_id,
    };

    if (editingIndex !== null && newItem.id) {
      await updateStockListItem(newItem);
      const updatedItems = [...items];
      updatedItems[editingIndex] = newItem;
      setItems(updatedItems);
      setEditingIndex(null);
    } else {
      setItems([...items, newItem]);
    }

    setAddData({
      item: "",
      quantity: "",
      weight: "",
      category: "",
      date: new Date().toISOString().split("T")[0],
      updated_by: "admin",
      status: "In Stock",
      overall_stock_id: stock_ids || "",
      product_id: "",
    });
  };

  const handleEditItem = (index) => {
    const itemToEdit = items[index];
    
    // Find the product ID from the item name
    const product = products.find(p => 
      (p.item_name_english === itemToEdit.item || p.item_name === itemToEdit.item)
    );
    const productId = product ? product.id : itemToEdit.product_id;

    setAddData({
      item: productId || itemToEdit.product_id || itemToEdit.item,
      quantity: itemToEdit.quantity.toString(),
      category: itemToEdit.category,
      weight: itemToEdit.weight,
      date: itemToEdit.date,
      updated_by: addData.updated_by,
      status: itemToEdit.status,
      overall_stock_id: itemToEdit.overall_stock_id,
      product_id: productId,
    });
    setEditingIndex(index);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
    setEditingIndex(null);
  };

  const calculateTotals = () => {
    const totalQuantity = items.reduce(
      (sum, item) => sum + parseInt(item.quantity || 0),
      0
    );
    const totalWeight = items.reduce(
      (sum, item) => sum + parseFloat(item.weight || 0),
      0
    );

    return {
      total_quantity: totalQuantity,
      total_weight: totalWeight.toFixed(2),
      avaliable_quantity: totalQuantity,
      sold_quantity: 0,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (items.length === 0) {
      toast.error("Please add at least one item", 3000, "topRight");
      return;
    }

    if (!stock_ids) {
      toast.error("No stock IDs provided for update", 3000, "topRight");
      return;
    }

    try {
      const totals = calculateTotals();
      const mainCategory = items[0]?.category || "";
      const mainItemName =
        items.length === 1 ? items[0].item : `${mainCategory} Items`;

      const payload = {
        item: mainItemName,
        quantity: totals.total_quantity.toString(),
        amount: "0.00",
        category: mainCategory,
        weight: `${totals.total_weight}g`,
        avaliable_quantity: totals.avaliable_quantity.toString(),
        total_quantity: totals.total_quantity.toString(),
        sold_quantity: totals.sold_quantity.toString(),
        updated_by: addData.updated_by,
        updated_date: new Date().toISOString(),
stock_list: items.map((item) => ({
  id: item.id || null,
  date: item.date,
  status: item.status,
  item: item.item,
  item_tamil: item.item_tamil,
  product_id: item.product_id,
  quantity: item.quantity.toString(),
  category: item.category,
  weight: `${item.weight}g`,
  created_by: item.created_by || addData.updated_by,
  created_date: item.created_date || new Date().toISOString(),
  updated_by: addData.updated_by,
  updated_date: new Date().toISOString(),
  overall_stock_id: item.overall_stock_id || stock_ids,
})),
      };

      const response = await axios.put(`${ApiUrl}/Api/stock.php?stock_ids=${stock_ids}`, payload);

      toast.success("Stock updated successfully!", 3000, "topRight");
      setItems([]);
      navigate("/stocks");
    } catch (error) {
      console.error("Error submitting data:", error.message);
      toast.error(
        "Error submitting data: " + (error.response?.data?.message || error.message),
        3000,
        "topRight"
      );
    }
  };

  return (
    <div className="container-fluid">
      <div className="card card-body">
        <h6 className="mb-3">{stock_ids ? "Edit Stock Items" : "Add Stock Items"}</h6>
        <div className="row">
          <div className="col-md-2">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={addData.date}
              onChange={(e) =>
                setAddData({ ...addData, date: e.target.value })
              }
              required
            />
          </div>

          <div className="col-md-2">
            <label className="form-label">Category</label>
            <select
              className="form-select"
              value={addData.category}
              onChange={(e) =>
                setAddData({ ...addData, category: e.target.value })
              }
              required
            >
              <option value="">Select Category</option>
              <option value="Gold">Gold</option>
              <option value="Silver">Silver</option>
              <option value="Gold Coin">Gold Coin</option>
              <option value="Silver Coin">Silver Coin</option>
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Item Name</label>
            <select
              className="form-select"
              value={addData.item}
              onChange={(e) => {
                setAddData({ ...addData, item: e.target.value, product_id: e.target.value });
              }}
              disabled={!addData.category}
              required
            >
              <option value="">Select Item</option>
              {filteredProducts.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.item_name_tamil
                    ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
                    : (product.item_name_english || product.item_name)}
                </option>
              ))}
            </select>
            {!addData.category && (
              <small className="text-muted text-danger">Please select category first</small>
            )}
          </div>

          <div className="col-md-1">
            <label className="form-label">Quantity</label>
            <input
              type="text"
              inputMode="numeric"
              className="form-control"
              placeholder="Quantity"
              value={addData.quantity}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,5}$/.test(value)) {
                  setAddData({ ...addData, quantity: value });
                }
              }}
              required
            />
          </div>

          <div className="col-md-2">
            <label className="form-label">Weight (g)</label>
            <input
              type="text"
              inputMode="decimal"
              className="form-control"
              placeholder="Weight"
              value={addData.weight}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(value)) {
                  setAddData({ ...addData, weight: value });
                }
              }}
              required
            />
          </div>

          <div className="col-md-2">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={addData.status}
              onChange={(e) =>
                setAddData({ ...addData, status: e.target.value })
              }
              required
            >
              <option value="In Stock">In Stock</option>
              <option value="Out of Stock">Out of Stock</option>
            </select>
          </div>

          <div className="col-md-1 d-flex align-items-end">
            <button
              className={`btn btn-sm w-100 ${
                editingIndex === null ? "btn-success" : "btn-primary"
              }`}
              onClick={handleAddItem}
              type="button"
            >
              <i
                className={`bi ${
                  editingIndex === null ? "bi-plus" : "bi-check"
                }`}
              ></i>
            </button>
          </div>

          <div className="col-md-2 col-lg-2 col-sm-3 d-flex align-items-end">
            <button
              className="btn btn-primary w-100"
              onClick={handleSubmit}
              disabled={items.length === 0}
            >
              {stock_ids ? "Update" : "Submit"}
            </button>
          </div>
        </div>
      </div>

      <div className="container-fluid py-3">
        <div className="card shadow-sm">
          <div className="card-body">
            {items.length > 0 && (
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="alert alert-info">
                    <strong>Summary:</strong>
                    Total Items: {items.length} | Total Quantity:{" "}
                    {items.reduce(
                      (sum, item) => sum + parseInt(item.quantity || 0),
                      0
                    )}{" "}
                    | Total Weight:{" "}
                    {items.reduce(
                      (sum, item) => sum + parseFloat(item.weight || 0),
                      0
                    ).toFixed(2)}
                    g
                  </div>
                </div>
              </div>
            )}

            <div className="card tableCard p-2">
              <div className="table-responsive">
                <table className="table">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Item</th>
                      <th>Quantity</th>
                      <th>Weight (g)</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.length > 0 ? (
                      items.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.date}</td>
                          <td>{item.category}</td>
                          <td>{item.item_tamil ? `${item.item} / ${item.item_tamil}` : item.item}</td>
                          <td>{item.quantity}</td>
                          <td>{item.weight}g</td>
                          <td>{item.status}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-light me-1"
                              onClick={() => handleEditItem(index)}
                            >
                              <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() => handleRemoveItem(index)}
                            >
                              <i className="fa-solid fa-trash text-danger fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No items added yet
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditStock;